export default __webpack_public_path__ + "static/media/icon-close-sp.32d19af8.svg";